import React, { FC, useEffect } from 'react';

import { Typography } from '@mui/material';
import { Trans, useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';

import DoneImg from '~/assets/images/done.webp';
import DonePreviewImg from '~/assets/images/done_preview.png';
import Button from '~/components/atoms/buttons/Button';
import Image from '~/components/atoms/Image';
import { useIsViewport, Viewports } from '~/hooks/useIsViewport';
import { SubscriptionPath } from '~/modules/settings/constants';
import projectConfig from '~/projects/config';
import analytics from '~/services/analytics';
import { Typographies } from '~/theme/typography';

import styles from './styles.module.scss';

const Success: FC = () => {
  const { t } = useTranslation('cancellation');
  const isDesktop = useIsViewport(Viewports.EXTRA_SMALL_DESKTOP);
  const { state } = useLocation();
  const navigate = useNavigate();

  const handleGoToSubscriptionPage = (): void => {
    navigate(SubscriptionPath);
  };

  useEffect(() => {
    if (!state) {
      handleGoToSubscriptionPage();
      return;
    }

    analytics.trackEvent('subscription - verify cancel sub');
  }, [state]);

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <div className={styles.image}>
          <Image src={DoneImg} preview={DonePreviewImg} />
        </div>

        <Typography
          variant={Typographies.HEADLINE_MEDIUM}
          component="h4"
          className={styles.title}
        >
          {t('v3.success.title_v1', {
            project: projectConfig.getProjectName(),
            defaultValue: 'Thank your for using {{project}}!',
          })}
        </Typography>

        <Typography
          variant={Typographies.TITLE_MEDIUM}
          component="p"
          className={styles.text}
        >
          <Trans i18nKey="v3.success.text" t={t}>
            You have successfully canceled your subscription.
            <br />
            <br />
            You can still enjoy the benefits of your account until the end of
            the billing period.
            <br />
            <br />
            We hope to see you again soon!
          </Trans>
        </Typography>
      </div>

      <Button
        variant="contained"
        color="primary"
        onClick={handleGoToSubscriptionPage}
        fullWidth={!isDesktop}
        sx={{ '&&': { marginTop: '40px' } }}
      >
        {t('v3.success.submit_button', 'Go to Settings')}
      </Button>
    </div>
  );
};

export default Success;
